// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userlist-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .userlist-title {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .userlist-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 10px;
    background-color: #f9f9f9;
    transition: background-color 0.3s ease;
  }
  
  .userlist-row:hover {
    background-color: #f1f1f1;
  }
  
  .userlist-info {
    display: flex;
    flex-wrap: wrap;
  }
  
  .userlist-field {
    margin-right: 20px;
    margin-bottom: 5px;
  }
  
  .userlist-label {
    font-weight: bold;
    margin-right: 5px;
  }
  
  .userlist-remove-button {
    padding: 8px 12px;
    background-color: #e74c3c;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .userlist-remove-button:hover {
    background-color: #c0392b;
  }
  
  .userlist-loading,
  .userlist-error,
  .userlist-empty {
    text-align: center;
    padding: 20px;
    font-size: 18px;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Admin/components/roles/UserList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;IAGE,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB","sourcesContent":[".userlist-container {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  .userlist-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .userlist-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border: 1px solid #ddd;\r\n    border-radius: 6px;\r\n    padding: 15px;\r\n    margin-bottom: 10px;\r\n    background-color: #f9f9f9;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .userlist-row:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n  \r\n  .userlist-info {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .userlist-field {\r\n    margin-right: 20px;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .userlist-label {\r\n    font-weight: bold;\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  .userlist-remove-button {\r\n    padding: 8px 12px;\r\n    background-color: #e74c3c;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .userlist-remove-button:hover {\r\n    background-color: #c0392b;\r\n  }\r\n  \r\n  .userlist-loading,\r\n  .userlist-error,\r\n  .userlist-empty {\r\n    text-align: center;\r\n    padding: 20px;\r\n    font-size: 18px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
